module.exports = __webpack_public_path__ + "media/images/guide-thumb-7-cf855b3b015dcaf6b89e75dd62f2cdc8.png";